import './ClientHeader.css';

function formatDate(dateString) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
}

export default function ClientHeader({ client, users }) {
  const { name, email, phone, rmUserId, plannerUserId, pipelineVersionTag, onboardedAt, overallPercent, hasPendingReview } = client;

  const rmUser = users ? users.find(u => u._id === rmUserId) : null;
  const plannerUser = users ? users.find(u => u._id === plannerUserId) : null;

  const rmName = rmUser ? rmUser.name : '—';
  const plannerName = plannerUser ? plannerUser.name : '—';
  const percent = overallPercent || 0;

  return (
    <div className="cj-header">
      <div className="cj-header__top">
        <div className="cj-header__name-row">
          <h2 className="cj-header__name">{name}</h2>
          <span className="cj-header__percent">{percent}%</span>
          {hasPendingReview && (
            <span className="cj-header__badge cj-header__badge--review">Pending Review</span>
          )}
        </div>
        <div className="cj-header__contacts">
          {email && <span className="cj-header__contact">{email}</span>}
          {phone && <span className="cj-header__contact">{phone}</span>}
        </div>
      </div>

      <div className="cj-header__progress-bar">
        <div className="cj-header__progress-fill" style={{ width: `${percent}%` }} />
      </div>

      <div className="cj-header__meta-row">
        <span className="cj-header__meta-item">
          <span className="cj-header__meta-label">RM</span>
          <span className="cj-header__meta-value">{rmName}</span>
        </span>
        <span className="cj-header__meta-sep" />
        <span className="cj-header__meta-item">
          <span className="cj-header__meta-label">Planner</span>
          <span className="cj-header__meta-value">{plannerName}</span>
        </span>
        <span className="cj-header__meta-sep" />
        <span className="cj-header__meta-item">
          <span className="cj-header__meta-label">Pipeline</span>
          <span className="cj-header__meta-value">{pipelineVersionTag || '—'}</span>
        </span>
        <span className="cj-header__meta-sep" />
        <span className="cj-header__meta-item">
          <span className="cj-header__meta-label">Onboarded</span>
          <span className="cj-header__meta-value">{formatDate(onboardedAt)}</span>
        </span>
      </div>
    </div>
  );
}
